<template>
	<div class="defendant sub_panel">
		<section-title v-on:toggleExpansion="toggleExpansion" title="Defendant" :is-expanded="is_expanded"></section-title>
		<el-collapse-transition>
			<div class="panel_detail" v-show="is_expanded">
				<el-form-item label="FIRST NAME" prop="defendant.first_name" :rules="validation.first_name">
					<el-input v-model="first_name" minlength="3" :maxlength="input_max" clearable></el-input>
				</el-form-item>
				<el-form-item label="MIDDLE NAME" prop="defendant.middle_name" :rules="validation.middle_name">
					<el-input v-model="middle_name" :maxlength="input_max" clearable></el-input>
				</el-form-item>
				<el-form-item label="LAST NAME" prop="defendant.last_name" :rules="validation.last_name">
					<el-input v-model="last_name" minlength="3" :maxlength="input_max" clearable></el-input>
				</el-form-item>
				<el-form-item label="ARREST DATE" prop="defendant.arrest_date">
					<el-date-picker format="MM/dd/yyyy" value-format="MM/dd/yyyy" type="date" v-model="arrest_date"></el-date-picker>
				</el-form-item>
				<el-form-item label="EVENT DESCRIPTION" prop="defendant.event_description">
					<el-select placeholder="" v-model="event_description">
						<el-option label="All" :value="null"></el-option>
						<el-option v-for="(event_description, index) in event_descriptions" :key="index" :label="event_description" :value="event_description"></el-option>
					</el-select>
				</el-form-item>
			</div>
		</el-collapse-transition>
	</div>
</template>

<script>
import panel_mixin from './panel-mixin.js';
import sectionTitle from './Section-Title.vue';
import { mapFields } from 'vuex-map-fields';
export default{
	mixins: [panel_mixin],
	components: {
		sectionTitle
	},
	mounted(){
		this.initEventDescriptions();
		console.log(this.getTheThings);
	},
	computed: {
		...mapFields(['input_max']),
		...mapFields('defendant', ['is_expanded', 'first_name', 'middle_name', 'last_name', 'arrest_date', 'event_description']),
		...mapFields('attorney_judge', ['judge'])
	},
	data(){
		return {
			event_descriptions: [],
			validation: {
				first_name: [
					// {required: true, message: "Please enter the Defendant's first name"},
					{ min: 3, message: "Should at least be three characters", trigger: "blur"},
					// { validator: this.requirementValidation, trigger: "blur" }
				],
				middle_name: [
					// {required: true, message: "Please enter the Defendant's first name"},
					{ min: 3, message: "Should at least be three characters", trigger: "blur"},
					// { validator: this.requirementValidation, trigger: "blur" }
				],
				last_name: [
					// {required: true, message: "Please enter the Defendant's last name"},
					{ min: 3, message: "Should at least be three characters", trigger: "blur"},
					// { validator: this.requirementValidation, trigger: "blur" }
				]
			}
		}
	},
	methods: {
		// requirementValidation(rule, value, callback){
		// 	if((!this.first_name || !this.last_name)){
		// 		callback(new Error('First and Last name necessary if searching by defendant.'))
		// 	}
		// 	else{callback()}
		// },
		initEventDescriptions(){
			this.$axios.get('/event-descriptions.php')
			.then( (response)=> {
				this.event_descriptions = response.data;
			})
		}
	}
}
</script>

<style scoped>
.defendant >>> .el-date-editor{
	width:100%;
}
.defendant >>> .el-date-editor .el-input__inner{
	padding-left:37px;
}
.defendant >>> .el-select{
	width:100%;
}
.defendant >>> .el-select-dropdown .el-select-dropdown__item{
	font-size:30px;
}
</style>
